<template>
    <div id="app">

        <router-view></router-view>

    </div>
</template>

<script>
import '../node_modules/vanilla-cookieconsent/dist/cookieconsent.css';
import '../node_modules/vanilla-cookieconsent/dist/cookieconsent.js';

window.hasGACookies = false;
window._blocked = false;

export default {
    name: 'app',
    data() {
        return {
            analyticsCookiesEnabled: false,

            pageview: {
                hash: null,
                title: null
            }
        };
    },
    methods: {
        acceptedCookies(cookie) {
            this.analyticsCookiesEnabled = cookie.categories.includes('analytics');

            if (this.analyticsCookiesEnabled) {
                window.hasGACookies = true;

                this.$gtag.enable();
            }
        }
    },
    mounted() {
        fetch('/ad_side.webp', {
            cache: "no-cache",
            headers: {
                "Content-Type": "image/webp",
            }
        }).catch(() => {
            window._blocked = true;
        });

        // eslint-disable-next-line
        const consent = initCookieConsent();

        const lang = this.$i18n.locale;

        consent.run({
            force_consent: true,
            current_lang: lang,
            onAccept: (cookie) => {
                this.acceptedCookies(cookie);
            },
            languages: {
                [lang]: {
                    consent_modal: {
                        title: this.$t("cookie.title"),
                        description: this.$t("cookie.description"),
                        primary_btn: {
                            text: this.$t("cookie.accept"),
                            role: 'accept_all'
                        },
                        secondary_btn: {
                            text: this.$t("cookie.reject"),
                            role: 'accept_necessary'
                        }
                    },
                    settings_modal: {
                        title: this.$t("cookie.preferences"),
                        save_settings_btn: this.$t("cookie.save"),
                        accept_all_btn: this.$t("cookie.accept"),
                        reject_all_btn: this.$t("cookie.reject"),
                        close_btn_label: this.$t("cookie.close"),
                        blocks: [
                            {
                                title: this.$t("cookie.block_1"),
                                description: this.$t("cookie.block_1_text")
                            },
                            {
                                title: this.$t("cookie.block_2"),
                                description: this.$t("cookie.block_2_text"),
                                toggle: {
                                    value: 'necessary',
                                    enabled: true,
                                    readonly: true
                                }
                            },
                            {
                                title: this.$t("cookie.block_3"),
                                description: this.$t("cookie.block_3_text"),
                                toggle: {
                                    value: 'analytics',
                                    enabled: true,
                                    readonly: false
                                }
                            },
                            {
                                title: this.$t("cookie.block_4"),
                                description: this.$t("cookie.block_4_text")
                            }
                        ]
                    }
                }
            }
        });
    }
}
</script>
